<template>
	<div>
		<!-- 店铺详情 -->
		<cube-page title="店铺设置">
			<div slot="content">
				<div class="shopxq leopages">
					<van-form @submit="onSubmit">
						<van-field v-model="entry.storename" clearable label="小店名称" placeholder="小店名称" name="storename" required
							:rules="[{ required: true, message: '请填写小店名称' }]" />
						<van-field v-model="entry.contacts" clearable label="联系人" placeholder="联系人" name="contacts" required
							:rules="[{ required: true, message: '请填写联系人' }]" />
						<van-field v-model="entry.address" clearable label="地址" placeholder="地址" name="address" required
							:rules="[{ required: true, message: '请填写地址' }]" />
						<van-field v-model="entry.mobile" clearable label="手机号码" placeholder="手机号码" name="mobile" required
							:rules="[{ required: true, message: '请填写手机号码' }]" />
						<van-field v-model="entry.notice" clearable rows="1" autosize label="店宣" type="textarea" name="dx"
							placeholder="请输入店宣" required :rules="[{ required: true, message: '请输入店宣' }]" />
						<van-radio-group v-model="entry.type" direction="horizontal" class="van-cell" @change="onChangeType">
							<div class="van-cell__title van-field__label"><span>提现类型</span></div>
							<van-radio name="10">微信零钱</van-radio>
							<van-radio name="20">银行转账</van-radio>
						</van-radio-group>
						<div v-if="isShowBox">
							<van-field v-model="entry.user_name" clearable autosize label="真实姓名" name="user_name"
								placeholder="请输入真实姓名,银行转账必须" />
							<van-field v-model="entry.ID_card" clearable autosize label="身份证号" name="ID_card"
								placeholder="请输入身份证号,银行转账必须" />
							<van-field v-model="entry.bank_card" clearable autosize label="银行卡号" name="bank_card"
								placeholder="请输入银行卡号,银行转账必须" />
						</div>
						<van-field name="avatar" label="头像" v-if="!isAdd">
							<template #input>
								<van-uploader :after-read="afterRead" v-model="fileList" :max-count="1" />
							</template>
						</van-field>
						<van-field name="idcard" label="有效证件" required :rules="[{ required: true, message: '请上传有效证件' }]">
							<template #input>
								<van-uploader :after-read="afterReadId" v-model="fileIdList" :max-count="1" />
							</template>
						</van-field>
						<van-field label="开通分销商" name="dtd" style="align-items: center;" class="vanfield">
							<template #input>
								<van-checkbox v-model="entry.dtd" shape="square"></van-checkbox>
							</template>
						</van-field>
						<div style="margin: 16px;">
							<van-button round block type="info" native-type="submit">提交</van-button>
						</div>
						<van-field name="checkbox" class="tk">
							<template #input>
								<van-checkbox v-model="checked">我已阅读，并同意<a @click="goXieyi">《免责申明》和《用户注册服务协议》</a>
								</van-checkbox>
							</template>
						</van-field>
					</van-form>
				</div>
			</div>

		</cube-page> <!-- 剪裁图片组件 -->
		<van-popup class="bg-tran" v-model="showCropper" closeable position="top" :style="{ height: '100%' }">
			<div class="flex-column-center height100">
				<vueCropper ref="cropper" :img="option.img" :outputSize="option.outputSize" :outputType="option.outputType"
					:info="option.info" :full="option.full" :autoCropWidth="option.autoCropWidth"
					:autoCropHeight="option.autoCropHeight" :canMove="option.canMove" :canMoveBox="option.canMoveBox"
					:original="option.original" :autoCrop="option.autoCrop" :fixed="option.fixed"
					:fixedNumber="option.fixedNumber" :centerBox="option.centerBox" :infoTrue="option.infoTrue"
					:fixedBox="option.fixedBox" :high="option.high" :mode="option.mode"></vueCropper>
				<div class="footerB">
					<div class="fitem" @click="cancelCropper">
						<span style="font-size: 14px;">取消</span>
					</div>
					<div class="fitem" @click="rotateImage">
						<van-icon name="replay" size="20" />
					</div>
					<div class="fitem" @click="getCropBlob">
						<van-button type="primary" size="small">确认</van-button>
					</div>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		Toast,
		Dialog
	} from 'vant';
	import CubePage from '../TP/cube-page.vue'
	import * as util from '@/utils/network'
	import * as imgcl from '@/utils/img'
	import wx from 'weixin-js-sdk'
	import Exif from "exif-js";

	import {
		VueCropper
	} from 'vue-cropper'
  import {redirect} from "@/utils/network";
	export default {
		components: {
			CubePage,
			VueCropper
		},
		data() {
			return {
				isAdd: true,
				store: null,
				entry: {
					storename: '智慧旅游-让旅游更实惠',
					mobile: '',
					notice: '本地直销无差价，全场5折起～',
					address: '',
					contacts: '',
					avatar: '',
					idcard: '',
					dtd: 0,
					type: 10
				},
				avatarobj: '', //头像上传
				imageFileName: '',
				showCropper: false,
				option: {
					img: '',
					outputSize: 0.8,
					info: false, // 裁剪框的大小信息
					outputType: 'jpeg', // 裁剪生成图片的格式
					canScale: false, // 图片是否允许滚轮缩放
					autoCrop: true, // 是否默认生成截图框
					autoCropWidth: window.innerWidth - 130 + 'px', // 默认生成截图框宽度
					autoCropHeight: window.innerWidth - 130 + 'px', // 默认生成截图框高度
					high: true, // 是否按照设备的dpr 输出等比例图片
					fixedBox: true, // 固定截图框大小 不允许改变
					fixed: true, // 是否开启截图框宽高固定比例
					fixedNumber: [1, 1], // 截图框的宽高比例
					full: true, // 是否输出原图比例的截图
					canMoveBox: false, // 截图框能否拖动
					original: false, // 上传图片按照原始比例渲染
					centerBox: false, // 截图框是否被限制在图片里面
					infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
					mode: '100% auto' // 图片默认渲染方式
				},
				files: {
					name: "",
					type: "",
				},
				idcardobj: '', //证件上传
				fileList: [],
				fileIdList: [],
				strCropper: null,
				checked: false,
				isShowBox: false

			}
		},
		methods: {
			onChangeType(e) {
				let that = this
				console.log(e)
				if (e == 20) {
					that.isShowBox = true
				} else {
					that.isShowBox = false
				}
			},
			//跳转协议页
			goXieyi() {

        redirect('xieyi?place=101');

				// let that = this;
				// var url = "/addons/litestore/api.account/getAgree"
				// //这里直接调用网络接口
				// util.get(url, {
				// 		type: 1
				// 	},
				// 	function(result) {
				// 		if (result.code == 1) {
				// 			that.$router.push({
				// 				name: 'xieyi',
				// 				params: {
				// 					place: 101
				// 				}
				// 			})
				// 		} else {
				// 			Dialog.alert({
				// 				title: '温馨提示',
				// 				message: result.msg
				// 			})
				// 		}
				// 	},
				// );
			},
			getCropBlob() {
				let that = this
				that.$refs.cropper.getCropData((data) => {
					let file = imgcl.dataUrltoFile(data, that.files.name)
					this.imgPreview(file, 300);
					that.showCropper = false //隐藏裁剪遮罩
				});
			},
			// 取消
			cancelCropper() {
				this.showCropper = false
			},
			rotateImage() {
				this.$refs.cropper.rotateRight();
			},
			afterRead(file) {
				this.avatarobj = ''
				this.files.name = file.file.name; // 获取文件名
				this.files.type = file.file.type; // 获取类型
				this.showCropper = true
				this.strCropper = 'avatar'
				this.option.img = file.content //清空上一次裁剪的图片
			},
			afterReadId(file) {
				this.idcardobj = ''
				this.files.name = file.file.name; // 获取文件名
				this.files.type = file.file.type; // 获取类型
				this.showCropper = true
				this.strCropper = 'idcard'
				this.option.img = file.content //清空上一次裁剪的图片
			},
			imgPreview(file, sizekb) {
				let self = this;
				// self.option.img = '' //清空上一次裁剪的图片
				let Orientation;
				//去获取拍照时的信息，解决拍出来的照片旋转问题   npm install exif-js --save   这里需要安装一下包
				Exif.getData(file, function() {
					Orientation = Exif.getTag(this, "Orientation");
				});
				// 看支持不支持FileReader
				if (!file || !window.FileReader) return '不支持FileReader';
				if (/^image/.test(file.type)) {
					// 创建一个reader
					let reader = new FileReader();
					// 将图片2将转成 base64 格式
					reader.readAsDataURL(file);
					// 读取成功后的回调
					reader.onloadend = function() {
						let result = this.result;
						let img = new Image();
						img.src = result;
						//判断图片是否大于500K,是就直接上传，反之压缩图片
						if (this.result.length <= sizekb * 1024) {
							// 上传图片
							console.log('小于：', this.result)
							console.log('小于：', self.strCropper)
							// self.option.img = this.result
							if (self.strCropper == 'avatar') {
								self.avatarobj = this.result;
							} else if (self.strCropper == 'idcard') {
								self.idcardobj = this.result;
								console.log('idcardobj<：', self.idcardobj)
							}
						} else {
							img.onload = function() {
								let data = imgcl.compress(img, Orientation);
								console.log('大于：', data)
								// self.option.img = data
								if (self.strCropper == 'avatar') {
									self.avatarobj = data
								} else if (self.strCropper == 'idcard') {
									self.idcardobj = data;
									console.log('idcardobj>：', self.idcardobj)
								}
							};
						}
					};
				}
			},
			onSubmit(values) {
				let that = this;
				if (!that.checked) {
					Toast('请勾选并阅读条款')
					return
				}
				if(that.avatarobj){
				  that.entry.avatar = that.avatarobj
				}else if(that.fileList.length>0){
				  that.entry.avatar = that.fileList[0].url
				}

				    // that.entry.avatar = that.avatarobj ? that.avatarobj : that.fileList[0].url

				that.entry.idcard = that.idcardobj ? that.idcardobj : that.fileIdList[0].url
				if (that.$route.query.share_id) {
					that.entry.share_id = this.$route.query.share_id
				}
				var pram = {
					row: that.entry
				};
				pram.row.pact =that.checked?1:0;
				console.log('pram', pram)
				var url = "/addons/litestore/api.account/applyStore"
				if (!that.isAdd) {
					url = "/addons/litestore/api.account/editStore"
					// pram.row['id'] = that.store
				}

				//这里直接调用网络接口
				util.post(url, pram,
					function(result) {
						Toast(result.msg);
						if (result.code === 1) {
							setTimeout(() => {
								if (that.isAdd && !result.data.subscribe) {
									util.redirect('newfollow');
									return false;
								}
								util.redirect(result.data.url);
								/*that.$router.back();
								that.claer();*/
							}, 1000)
						}
					},
				);
			},
			getData() {
				let that = this;
				//util.isToken
				var url = "/addons/litestore/api.account/editStore"
				let id = this.$store.getters.getShop
				//这里直接调用网络接口
				util.get(url, {
						store_id: id
					},
					function(result) {
						if (result.data != null) {
							that.isAdd = false
							let en = {
								id: result.data.id,
								storename: result.data.storename,
								mobile: result.data.mobile,
								notice: result.data.notice,
								address: result.data.address,
								contacts: result.data.contacts,
								avatar: result.data.avatar,
								idcard: result.data.idcard,
								type: result.data.type,
								user_name: result.data.user_name,
								ID_card: result.data.ID_card,
								bank_card: result.data.bank_card,
								dtd: result.data.dtd,
							}
							let a = [{
								url: result.data.avatar
							}]
							that.fileList = a
							let b = [{
								url: result.data.idcard
							}]
							that.fileIdList = b
							that.entry = en
							that.checked = result.data.pact;
						}
					},
				);
			},
			claer() {
				let that = this;
				that.entry = {
					nickname: '', //	公司名称
					username: '', //用户名
					password: '', //密码
					mobile: '', //	联系电话
					landline: '', //		座机
					address: '', //	地址
					contacts: '', //	联系人
					avatar: [] //	执照
				}
				that.imageFileName = ''
				that.showCropper = false
			},
		},
		created() {
			// this.store = this.$store.getters.getShop
			this.getData()
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			// "$store.state.shop"() {
			// 	this.store = this.$store.getters.getShop
			// }
		},
	}
</script>
<style type="text/css" lang="less">
	.van-form {
		background-color: #FFFFFF;
		padding: 20px 0;

		.tk {
			font-size: 12px;
			text-align: center;

			a {
				color: #000;
			}

			.van-field__control:read-only {
				justify-content: center !important;
			}
		}
	}

	.van-nav-bar {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
	}

	.van-hairline--bottom::after {
		border-bottom-width: 0px;
	}

	.height100 {
		height: 100vh;
	}

	.flex-column-center {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.vue-cropper {
		background: #000 !important;

		.cropper-view-box {
			outline: 1px solid #fff !important;
			outline-color: #fff !important;
		}
	}

	.footerB {
		background: #000 !important;
		padding: 10px 15px;
		width: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		align-items: center;

		.fitem {
			color: #FFFFFF;
			// width:50px;
		}
	}

	.vanfield {
		.van-field__value {
			flex: none;
		}
		.van-icon-success {
			border-radius: 4px;
		}
	}
</style>
